import React from "react";

import styled from "styled-components/macro";

import FnrTypography from "FnrTypography";

import FnrButton3 from "UI/FnrButton3";
import FnrIconBubbles from "UI/FnrIconBubbles";

import { useGetBackgroundColorData } from "../../../API/queryHooks";

const EmptyState = ({ type, searchTerm, triggerLogin }) => {
  const { textColor } = useGetBackgroundColorData();

  const renderContent = () => {
    switch (type) {
      case "login":
        return (
          <>
            <FnrIconBubbles icon="fa-lock fad fa-sm" />
            <FnrTypography
              type="subheader"
              fontWeight={600}
              fontSize="decorative1"
              color={textColor}
              xMarginAdjust={20}
              style={{ marginBottom: "10px" }}
            >
              Please log in to view your notes
            </FnrTypography>
            <FnrButton3 borderRadius={9999} color="blue" onClick={triggerLogin}>
              Log In
            </FnrButton3>
          </>
        );

      case "no-notes":
      default:
        return (
          <>
            <FnrIconBubbles icon="envelope-open fas fa-sm" />
            <FnrTypography
              type="subheader"
              fontWeight={600}
              fontSize="decorative1"
              color={textColor}
              xMarginAdjust={20}
            >
              {searchTerm?.trim()
                ? `No matches - try another search!`
                : "Looks like you don't have any notes yet"}
            </FnrTypography>
          </>
        );
    }
  };

  return <EmptyStateContainer>{renderContent()}</EmptyStateContainer>;
};

const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  text-align: center;
  font-size: 1.2rem;
  margin-top: 50px;
  gap: 25px;
`;

export default EmptyState;
